import { useState } from "react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Operations Director",
    company: "Apex Logistics",
    avatar: "https://public.readdy.ai/ai/img_res/64ba4063b2b6ee3918e53c08923eda52.jpg",
    quote:
      "SilentNet completely transformed our IT infrastructure. Their team responded within the hour and had our network back online before we even realized the full scope of the issue. Absolutely outstanding service.",
    rating: 5,
  },
  {
    name: "James Okafor",
    role: "CEO",
    company: "Brightfield Consulting",
    avatar: "https://readdy.ai/api/search-image?query=professional%20businessman%20headshot%2C%20confident%20smile%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20corporate%20portrait%20photography&width=120&height=120&seq=avatar-002&orientation=squarish",
    quote:
      "We've been with SilentNet for 3 years now. Their managed IT service means I never have to worry about downtime or security threats. It's like having a full IT department without the overhead.",
    rating: 5,
  },
  {
    name: "Linda Zhao",
    role: "IT Manager",
    company: "Meridian Healthcare",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20headshot%2C%20warm%20smile%2C%20clean%20office%20background%2C%20natural%20lighting%2C%20corporate%20portrait%20photography&width=120&height=120&seq=avatar-003&orientation=squarish",
    quote:
      "The cybersecurity audit SilentNet performed revealed vulnerabilities we didn't even know existed. Their team was thorough, professional, and explained everything in plain language. Highly recommend.",
    rating: 5,
  },
  {
    name: "Tom Harrington",
    role: "Founder",
    company: "Harrington & Co.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20middle-aged%20businessman%20headshot%2C%20friendly%20expression%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20corporate%20portrait%20photography&width=120&height=120&seq=avatar-004&orientation=squarish",
    quote:
      "Moving our entire office to the cloud seemed daunting, but SilentNet made it seamless. Zero downtime, everything migrated perfectly, and our team was up and running the same day.",
    rating: 5,
  },
  {
    name: "Priya Nair",
    role: "Finance Director",
    company: "Solaris Group",
    avatar: "https://readdy.ai/api/search-image?query=professional%20indian%20businesswoman%20headshot%2C%20confident%20smile%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20corporate%20portrait%20photography&width=120&height=120&seq=avatar-005&orientation=squarish",
    quote:
      "Fast, knowledgeable, and genuinely friendly. SilentNet's remote support team resolved our accounting software issue in under 20 minutes. That kind of efficiency is priceless during month-end.",
    rating: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((a) => (a === 0 ? testimonials.length - 1 : a - 1));
  const next = () => setActive((a) => (a === testimonials.length - 1 ? 0 : a + 1));

  const visible = [
    testimonials[(active) % testimonials.length],
    testimonials[(active + 1) % testimonials.length],
    testimonials[(active + 2) % testimonials.length],
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase mb-3 block">
            Client Stories
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Trusted by Businesses<br />Across the Region
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {visible.map((t, i) => (
            <div
              key={i}
              className={`rounded-2xl p-7 border transition-all duration-300 ${
                i === 0
                  ? "bg-teal-600 border-teal-600 text-white"
                  : "bg-gray-50 border-gray-100 text-gray-900"
              }`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <i
                    key={s}
                    className={`ri-star-fill text-sm ${i === 0 ? "text-yellow-300" : "text-yellow-400"}`}
                  />
                ))}
              </div>
              <p
                className={`text-sm leading-relaxed mb-6 ${
                  i === 0 ? "text-teal-50" : "text-gray-600"
                }`}
              >
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className={`font-semibold text-sm ${i === 0 ? "text-white" : "text-gray-900"}`}>
                    {t.name}
                  </div>
                  <div className={`text-xs ${i === 0 ? "text-teal-200" : "text-gray-400"}`}>
                    {t.role}, {t.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={prev}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:border-teal-500 hover:text-teal-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`w-2 h-2 rounded-full transition-all duration-200 cursor-pointer ${
                  i === active ? "bg-teal-500 w-6" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:border-teal-500 hover:text-teal-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
